<nav class="navigation">
  <ul class="link-wrapper">
    @for (item of navigationItems; track item.title) {
      @if (hasChildrenWithClaims(item) && item.hasClaims) {
        <app-navigation-dropdown [navigationItem]="item" link="/admin" />
      } @else {
        @if (item.hasClaims) {
          <li
            [ngClass]="{
              'navigation-item': true,
              active: isRouteActive(item.id)
            }">
            <a [routerLink]="item.url">
              {{ item.title | translate }}@if (item.id === 8 && unreadCount > 0) { ({{ unreadCount }})}
            </a>
          </li>
        }
      }
    }
  </ul>
</nav>
